import { render } from "./tabRefSelection.vue?vue&type=template&id=2c4bbb3a&scoped=true"
import script from "./tabRefSelection.vue?vue&type=script&lang=js"
export * from "./tabRefSelection.vue?vue&type=script&lang=js"

import "./tabRefSelection.vue?vue&type=style&index=0&id=2c4bbb3a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4bbb3a"]])

export default __exports__